import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { EventEmitter } from '@angular/core';
import { ReportRecord, ReportInfo, DataObject } from '../../models/report.model';

export function onDrop(
  { previousIndex, currentIndex }: CdkDragDrop<Array<{ [key: string]: any }>>,
  recordData: ReportRecord,
  reportData: ReportInfo,
  reportReordered: EventEmitter<ReportRecord[]>,
  recordNumber: number
) {
  recordData.data = recordData.data.slice();
  const positions = recordData.data.map(({ position }) => position);
  const indexes = [previousIndex, currentIndex].sort((a, b) => a - b);
  recordData.data = recordData.data.slice();
  moveItemInArray(recordData.data as any[], previousIndex, currentIndex);
  recordData.data = recordData.data.map((record, index) => ({
    ...record,
    position: positions[index],
  }));
  recordData.data.slice(indexes[0], indexes[1] + 1).map(({ recordId, position }) => ({ recordId, position }));
  const ungroupedRecords: ReportRecord[] = ungroupAvailabilityRecords(recordData.data, reportData, recordNumber);
  reportReordered.emit(ungroupedRecords);
}

export function ungroupAvailabilityRecords(
  data: DataObject,
  reportData: ReportInfo,
  recordNumber: number
): ReportRecord[] {
  reportData.records[recordNumber - 1].data = data;
  const result: ReportRecord[] = reportData.records.reduce(
    (acc, { associatedProperty, associatedPropertyId, edpRecordId, data }) => {
      data.forEach((_, i) => {
        acc.push({
          associatedProperty,
          associatedPropertyId,
          edpRecordId,
          recordId: data[i].recordId,
          position: data[i].position,
          data: data[i],
        });
      });
      return acc;
    },
    []
  );
  return result;
}
